import styled from '@emotion/styled';
import { Checkbox, Typography } from '@innovamat/glimmer-components';

const CheckBoxContainer = styled.div<{ checked: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid
    ${({ theme }) => theme.tokens.color.global.neutral['neutral300'].value};
  background-color: ${({ theme, checked }) =>
    checked
      ? theme.tokens.color.global.neutral['neutral100'].value
      : 'transparent'};
  &:hover {
    background-color: ${({ theme }) =>
      theme.tokens.color.global.neutral['neutral100'].value};
  }
  padding: 4px;
  border-radius: 8px;
  width: fit-content;
  max-width: 250px;
  min-width: 100px;
  cursor: pointer;

  > p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
  }
`;

const CustomCheckBox = ({
  text,
  checked = false,
  onCheck,
}: {
  text: string;
  checked?: boolean;
  onCheck?: (checked: boolean) => void;
}): JSX.Element => {
  const handleContainerClick = () => {
    onCheck?.(!checked);
  };

  return (
    <CheckBoxContainer onClick={handleContainerClick} checked={checked}>
      <Checkbox checked={checked} onCheck={onCheck} />
      <Typography.Body3>{text}</Typography.Body3>
    </CheckBoxContainer>
  );
};

export { CustomCheckBox };
